// extracted by mini-css-extract-plugin
module.exports = {"name":"productloadinglist_name__1Z-QH","animated-background":"productloadinglist_animated-background__2Ohde","placeHolderShimmer":"productloadinglist_placeHolderShimmer__3ykc2"};